import { useTheme } from '@mui/material'
import React from 'react'

interface Props {
  textColor?: string
  worldColor?: string
  containerStyle?: string
}

/**
 * E3DC Logo including it's icon and a slogan.
 *
 * @beta need to be accepted by ui/ux team
 * @see https://www.figma.com/design/2XkUgderL8Y8WDXHPhUXNJ/E3DC-Component-Catalog?node-id=4343-114&t=gGYPmS7gWf6fXIIB-1
 */
const FullE3dcLogo: React.FC<Props> = ({ textColor, worldColor, containerStyle }) => {
  const theme = useTheme()
  const textColorToUse = textColor ?? theme.palette.background.header
  const worldColorToUse = worldColor ?? theme.palette.primary.main

  return (
    <svg id="Ebene_1" x="0px" y="0px" viewBox="0 0 105 61.8" xmlSpace="preserve" className={containerStyle}>
      <style type="text/css">
        {`\n\t.Gr\xFCn_x0020_bogenf\xF6rmig{fill:url(#SVGID_1_);stroke:${textColorToUse};stroke-width:0.25;stroke-miterlimit:1;}\n\t.st0{fill:${worldColorToUse};}\n\t.st1{fill:${textColorToUse};}\n`}
      </style>
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1={0} y1={788.8515} x2={0.7071} y2={788.1444}>
        <stop
          offset={0}
          style={{
            stopColor: '#349629',
          }}
        />
        <stop
          offset={0.9831}
          style={{
            stopColor: '#101D0E',
          }}
        />
      </linearGradient>
      <g>
        <path
          className="st0"
          d="M63.9,28.3c-2.1-6.9-6.8-11.9-11.5-14.6c-9.6-5.5-16.8-2.9-16.6-2.8c-0.1,0.7,6.9-1.1,15.6,4.4 c3.2,2.1,6.5,5.4,8.6,9.8c0.7,6.9-6,8.2-7.9,2.5c-2.1-6.6-3.8-9.5-6.4-9.1c-2.4,0.3-4.5,6.7-5.3,9.5s-3.1,10.8-4.8,14.4 c-1.7,3.6-4.2,5.2-6.7,5.2s-4.4-1.7-6.5-5.7c-0.7-0.1-2.6-0.4-2.6-0.4c1,5.1,5.3,10.7,9.7,10.6c4.3-0.1,6.5-3,8.8-9.3 c2.3-6.3,4.1-12.7,8-12.9c3.2-0.2,3.7,4,4.6,7c0.9,3,2.4,8.6,6.6,8.7c1.6,0,2.8-1,3.7-2.4c-0.7,2.1-1.7,4.2-3,6.1 C53.9,55.4,47,59,40.5,59.4c-6.6,0.6-12.4-1.7-16.4-4.6c-8.1-6.2-9.1-13.4-9.6-13c-0.1-0.2,0,7.4,8.5,14.5c4.1,3.4,10.5,6,17.7,5.6 c7.2-0.3,15-4.3,19.7-11.2C65.2,43.8,66.1,35.1,63.9,28.3"
        />
        <path
          className="st1"
          d="M13.5,38.7H0.8c-0.4,0-0.8-0.3-0.8-0.8V11c0-0.4,0.3-0.8,0.8-0.8h12.7c0.4,0,0.8,0.3,0.8,0.8v1.7 c0,0.4-0.3,0.8-0.8,0.8H3.4v9.2h9.3c0.4,0,0.8,0.3,0.8,0.8v1.7c0,0.4-0.3,0.8-0.8,0.8H3.4v9.6h10.1c0.4,0,0.8,0.3,0.8,0.8v1.7 C14.2,38.3,13.9,38.7,13.5,38.7"
        />
        <path
          className="st1"
          d="M25.3,39.1c-3.2,0-5.8-0.8-5.8-0.8c-0.5-0.1-0.8-0.4-0.8-0.8v-1.8c0-0.4,0.3-0.6,0.8-0.5c0,0,3.5,0.7,5.8,0.7 c3.3,0,5.1-1.7,5.1-4.5v-1.7c0-2.8-1.8-4.1-4.8-4.1h-4c-0.4,0-0.8-0.3-0.8-0.8V23c0-0.4,0.3-0.8,0.8-0.8h3.2c3,0,4.8-1.3,4.8-4.1 v-0.9c0-2.8-1.7-4.2-4.5-4.2c-2.3,0-5.5,0.7-5.5,0.7c-0.4,0.1-0.8-0.1-0.8-0.6v-1.8c0-0.4,0.2-0.6,0.8-0.8c0,0,2.4-0.8,5.6-0.8 c5,0,7.9,2.3,7.9,7.5v0.9c0,2.6-1,4.4-2.8,5.5c2.2,1,3.6,3,3.6,6v1.7C33.7,36.6,30.7,39.1,25.3,39.1"
        />
        <path
          className="st1"
          d="M83.3,19.4c0-3.1-1.4-6-5.4-6h-5.4v22h5.4c4,0,5.4-2.9,5.4-6V19.4z M77.9,38.7h-8.1c-0.4,0-0.8-0.3-0.8-0.8V11 c0-0.4,0.3-0.8,0.8-0.8h8.1c6.1,0,8.8,3.9,8.8,9.2v10C86.7,34.8,84.1,38.7,77.9,38.7"
        />
        <path
          className="st1"
          d="M104,38.7c0,0-2.2,0.4-4.2,0.4c-5.8,0-8.5-3.9-8.5-9.2V19c0-5.3,2.6-9.2,8.5-9.2c2.2,0,4.2,0.4,4.2,0.4 c0.5,0.1,0.7,0.3,0.7,0.8v1.8c0,0.4-0.3,0.6-0.8,0.6c0,0-2.2-0.4-4-0.4c-3.8,0-5.2,2.9-5.2,6v10.8c0,3.1,1.4,6,5.2,6 c1.6,0,4-0.4,4-0.4c0.4,0,0.8,0.2,0.8,0.6v1.8C104.8,38.3,104.5,38.5,104,38.7"
        />
        <path
          className="st1"
          d="M38.8,6.6H36c-0.1,0-0.2-0.1-0.2-0.2V0.3c0-0.1,0.1-0.2,0.2-0.2h2.9c0.1,0,0.2,0.1,0.2,0.2v0.4 c0,0.1-0.1,0.2-0.2,0.2h-2.3V3h2.1c0.1,0,0.2,0.1,0.2,0.2v0.4c0,0.1-0.1,0.2-0.2,0.2h-2.1v2.2h2.3C38.9,5.9,39,5.9,39,6v0.4 C39,6.5,38.9,6.6,38.8,6.6"
        />
        <path
          className="st1"
          d="M44.4,6.6h-0.5c-0.1,0-0.2-0.1-0.2-0.2l-2.4-4.6v4.6c0,0.1-0.1,0.2-0.2,0.2h-0.4c-0.1,0-0.2-0.1-0.2-0.2V0.3 c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2l2.4,4.6V0.3c0-0.1,0.1-0.2,0.2-0.2h0.4c0.1,0,0.2,0.1,0.2,0.2v6.1 C44.5,6.5,44.5,6.6,44.4,6.6"
        />
        <path
          className="st1"
          d="M49.3,6.6h-2.9c-0.1,0-0.2-0.1-0.2-0.2V0.3c0-0.1,0.1-0.2,0.2-0.2h2.9c0.1,0,0.2,0.1,0.2,0.2v0.4 c0,0.1-0.1,0.2-0.2,0.2H47V3h2.1c0.1,0,0.2,0.1,0.2,0.2v0.4c0,0.1-0.1,0.2-0.2,0.2H47v2.2h2.3c0.1,0,0.2,0.1,0.2,0.2v0.4 C49.5,6.5,49.4,6.6,49.3,6.6"
        />
        <path
          className="st1"
          d="M52.8,0.9h-1v2.3h1C53.6,3.1,54,2.7,54,2C54,1.3,53.6,0.9,52.8,0.9 M54.9,6.6h-0.6c-0.1,0-0.2-0.1-0.2-0.2 l-1.5-2.5h-0.8v2.5c0,0.1-0.1,0.2-0.2,0.2h-0.4c-0.1,0-0.2-0.1-0.2-0.2V0.3c0-0.1,0.1-0.2,0.2-0.2h1.6c1.3,0,2,0.7,2,1.9 c0,1-0.5,1.6-1.4,1.8L55,6.4C55,6.5,55,6.6,54.9,6.6"
        />
        <path
          className="st1"
          d="M58.3,6.7c-1.4,0-2-0.9-2-2.1V2.3c0-1.4,0.7-2.3,2.2-2.3c0.8,0,1.5,0.2,1.5,0.2c0.1,0,0.2,0.1,0.2,0.2v0.4 C60.1,1,60.1,1,60,1c0,0-0.8-0.2-1.5-0.2c-1,0-1.4,0.7-1.4,1.5v2.3c0,0.7,0.3,1.4,1.2,1.4c0.8,0,1.2-0.3,1.2-0.3V3.8h-1.2 c-0.1,0-0.2-0.1-0.2-0.2V3.2c0-0.1,0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2v2.9C60.3,6.1,59.7,6.7,58.3,6.7"
        />
        <path
          className="st1"
          d="M64,4.4v2c0,0.1-0.1,0.2-0.2,0.2h-0.4c-0.1,0-0.2-0.1-0.2-0.2v-2l-1.8-4c0-0.1,0-0.2,0.1-0.2H62 c0.1,0,0.2,0.1,0.2,0.2l1.4,3.1L65,0.3c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.1,0.2L64,4.4z"
        />
        <path
          className="st1"
          d="M71.6,6.7c-0.7,0-1.4-0.2-1.4-0.2c-0.1,0-0.2-0.1-0.2-0.2V5.9c0-0.1,0.1-0.2,0.2-0.1c0,0,0.8,0.2,1.3,0.2 c0.7,0,1.2-0.3,1.2-1V4.7c0-0.6-0.3-0.8-0.9-1l-0.6-0.2C70.6,3.3,70,2.9,70,2V1.7c0-1.1,0.8-1.7,1.8-1.7c0.7,0,1.3,0.2,1.3,0.2 c0.1,0,0.2,0.1,0.2,0.2v0.4c0,0.1-0.1,0.2-0.2,0.1c0,0-0.7-0.1-1.3-0.1c-0.7,0-1.1,0.3-1.1,0.9V2c0,0.4,0.3,0.7,0.7,0.8L72.1,3 c0.7,0.2,1.3,0.6,1.3,1.7v0.3C73.4,6.2,72.7,6.7,71.6,6.7"
        />
        <path
          className="st1"
          d="M78.4,0.9H77v5.5c0,0.1-0.1,0.2-0.2,0.2h-0.4c-0.1,0-0.2-0.1-0.2-0.2V0.9h-1.4c-0.1,0-0.2-0.1-0.2-0.2V0.3 c0-0.1,0.1-0.2,0.2-0.2h3.6c0.1,0,0.2,0.1,0.2,0.2v0.4C78.6,0.8,78.5,0.9,78.4,0.9"
        />
        <path
          className="st1"
          d="M82.8,2.1c0-0.7-0.3-1.4-1.2-1.4c-0.9,0-1.2,0.7-1.2,1.4v2.4c0,0.7,0.3,1.4,1.2,1.4c0.9,0,1.2-0.7,1.2-1.4V2.1 z M81.6,6.7c-1.4,0-2-0.9-2-2.1V2.1c0-1.2,0.6-2.1,2-2.1c1.4,0,2,0.9,2,2.1v2.4C83.6,5.8,83,6.7,81.6,6.7"
        />
        <path
          className="st1"
          d="M87.1,0.9h-1v2.3h1c0.8,0,1.2-0.4,1.2-1.1C88.3,1.3,87.9,0.9,87.1,0.9 M89.1,6.6h-0.6c-0.1,0-0.2-0.1-0.2-0.2 l-1.5-2.5h-0.8v2.5c0,0.1-0.1,0.2-0.2,0.2h-0.4c-0.1,0-0.2-0.1-0.2-0.2V0.3c0-0.1,0.1-0.2,0.2-0.2h1.6c1.3,0,2,0.7,2,1.9 c0,1-0.5,1.6-1.4,1.8l1.5,2.6C89.3,6.5,89.2,6.6,89.1,6.6"
        />
        <path
          className="st1"
          d="M92.6,1.4l-1,3.2h2L92.6,1.4z M94.8,6.6h-0.5c-0.1,0-0.2-0.1-0.2-0.2l-0.3-1.1h-2.4L91,6.4 c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.1-0.2l1.9-6.1c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2L95,6.4 C95,6.5,94.9,6.6,94.8,6.6"
        />
        <path
          className="st1"
          d="M98.1,6.7c-1.4,0-2-0.9-2-2.1V2.3c0-1.4,0.7-2.3,2.2-2.3c0.8,0,1.5,0.2,1.5,0.2c0.1,0,0.2,0.1,0.2,0.2v0.4 C99.9,1,99.8,1,99.7,1c0,0-0.8-0.2-1.5-0.2c-1,0-1.4,0.7-1.4,1.5v2.3c0,0.7,0.3,1.4,1.2,1.4c0.8,0,1.2-0.3,1.2-0.3V3.8h-1.2 c-0.1,0-0.2-0.1-0.2-0.2V3.2c0-0.1,0.1-0.2,0.2-0.2h1.8c0.1,0,0.2,0.1,0.2,0.2v2.9C100.1,6.1,99.5,6.7,98.1,6.7"
        />
        <path
          className="st1"
          d="M104.8,6.6H102c-0.1,0-0.2-0.1-0.2-0.2V0.3c0-0.1,0.1-0.2,0.2-0.2h2.9c0.1,0,0.2,0.1,0.2,0.2v0.4 c0,0.1-0.1,0.2-0.2,0.2h-2.3V3h2.1c0.1,0,0.2,0.1,0.2,0.2v0.4c0,0.1-0.1,0.2-0.2,0.2h-2.1v2.2h2.3c0.1,0,0.2,0.1,0.2,0.2v0.4 C105,6.5,104.9,6.6,104.8,6.6"
        />
      </g>
    </svg>
  )
}

export default FullE3dcLogo
